<script setup lang="ts">
import { sub } from "date-fns";
import type { Period, Range } from "~/types";

const { isNotificationsSlideoverOpen, isGarnmentSlideoverOpen } =
  useDashboard();

import { dragAndDrop } from "@formkit/drag-and-drop/vue";

import { animations } from "@formkit/drag-and-drop";
const items = [
  [
    {
      label: "New mail",
      icon: "i-heroicons-paper-airplane",
      to: "/inbox",
    },
    {
      label: "New user",
      icon: "i-heroicons-user-plus",
      to: "/users",
    },
  ],
];

const models = ref([
  {
    id: 1,
    imageUrl: "/model555.png",
    name: "Ethan Bennett",
    price: "$99.99",
    key: "model555",
  },
  {
    id: 2,
    imageUrl: "/model5555.png",
    name: "Liam Carter",
    price: "$49.99",
    key: "shirt",
  },
  {
    id: 3,
    imageUrl: "/model55555.png",
    name: "Aiden Mitchell",
    price: "$129.99",
    key: "armani",
  },
  {
    id: 4,
    imageUrl: "/model555555.png",
    name: "Noah Harrison",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 5,
    imageUrl: "/models/550e8400-e29b-41d4-a716-446655440000/main.png",
    movieUrl: "/models/550e8400-e29b-41d4-a716-446655440000/main.mp4",
    name: "Simon Simonson",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 6,
    imageUrl: "/legend_old.png",
    name: "Sebastian Grey",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 7,
    imageUrl: "/white_old.png",
    name: "Jackson Taylor",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 8,
    imageUrl: "/models/03574b70-87c7-4379-aa4b-68d07c2690af/main.png",
    name: "James Thornton",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 9,
    imageUrl: "/models/11778178-7dcf-4873-9b5c-bb605ba058c1/main.png",
    movieUrl: "/models/11778178-7dcf-4873-9b5c-bb605ba058c1/main.mp4",
    name: "Daniel Pierce",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 10,
    imageUrl: "/models/879fa9ba-09de-40d4-acff-04ddcffa8098/main.png",
    name: "Julian Stone",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 11,
    imageUrl: "/models/1466c7ca-c760-4723-bab0-0e816803cd97/main.png",
    movieUrl: "/models/1466c7ca-c760-4723-bab0-0e816803cd97/main.mp4",
    name: "Samuel Hayes",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 12,
    imageUrl: "/models/619e6447-ef70-453a-921d-a2b9ee784246/main.png",
    name: "Jenni Likins",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 13,
    imageUrl: "/models/33656acc-403e-4a03-8ef7-d0d82872dda0/main.png",
    movieUrl: "/models/33656acc-403e-4a03-8ef7-d0d82872dda0/main.mp4",
    name: "Jenni Likins",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 14,
    imageUrl: "/models/36d941fe-6502-4ba1-9648-000a88113533/main.png",
    movieUrl: "/models/36d941fe-6502-4ba1-9648-000a88113533/main.mp4",
    name: "Natasha Novak",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 15,
    imageUrl: "/models/5fd82791-2e2d-45bc-aadc-36b24a2d456a/main.png",
    movieUrl: "/models/5fd82791-2e2d-45bc-aadc-36b24a2d456a/main.mp4",
    name: "Ray Novak",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 16,
    imageUrl: "/models/8089c409-0646-47f9-bf58-94d7728142cb/main.png",
    movieUrl: "/models/8089c409-0646-47f9-bf58-94d7728142cb/main.mp4",
    name: "Teniako Nakamur",
    price: "$79.99",
    key: "shirts",
  },
  {
    id: 17,
    imageUrl: "/models/f50a38f8-dbc8-412f-8e3e-370beb2e42a3/main.png",
    movieUrl: "/models/f50a38f8-dbc8-412f-8e3e-370beb2e42a3/main.mp4",
    name: "Drew McMillan",
    price: "$79.99",
    key: "shirts",
  },
]);
const listRef = ref();

dragAndDrop({
  parent: listRef,
  values: models,
  group: "models",
  // sortable: true,
  // dropZone: true,
  // dropZoneClass: "dragging",
  // draggingClass: "dragfly",
  plugins: [animations()],
});

const goToModel = async (modelId) => {
  await navigateTo(`/models/${modelId}`);
};

const range = ref<Range>({
  start: sub(new Date(), { days: 14 }),
  end: new Date(),
});
const period = ref<Period>("daily");
</script>

<template>
  <UDashboardPage>
    <UDashboardPanel grow>
      <UDashboardNavbar title="Gallery">
        <template #right>
          <UButton
            color="gray"
            variant="ghost"
            square
            @click="isGarnmentSlideoverOpen = true"
          >
            <UIcon name="i-heroicons-squares-plus" class="w-5 h-5" />
          </UButton>
          <div class="w-[200px]">
            <UserDropdown2 />
          </div>
        </template>
      </UDashboardNavbar>

      <UDashboardPanelContent>
        <!-- ~/components/home/HomeChart.vue -->
        <UDashboardToolbar class="pb-4 px-1.5 overflow-x-auto mb-4">
          <UBreadcrumb
            divider="/"
            :links="[
              { label: 'All models', to: '/' },
              { label: 'Male', to: '/' },
              { label: 'Beard' },
            ]"
          />
          <UButton
            icon="i-heroicons-plus"
            size="sm"
            variant="outline"
            label="Add folder"
          />
        </UDashboardToolbar>
        <div
          class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-7 gap-3"
          ref="listRef"
        >
          <div v-for="model in models" :key="model.key">
            <UCard
              @click="goToModel(model.id)"
              :ui="{
                background: 'dark:bg-[#1e1f21]',
                ring: 'ring-0',
                base: 'rounded-lg overflow-hidden hovercard cursor-pointer',
                body: 'px-0 py-0',
              }"
            >
              <!-- Photo of the garment -->
              <div class="h-40">
                <VideoBlock
                  v-if="model.movieUrl"
                  :videoSrc="model.movieUrl"
                  :imageSrc="model.imageUrl"
                />
                <img
                  v-if="!model.movieUrl"
                  draggable="false"
                  :src="model.imageUrl"
                  alt="Garment Photo"
                  class="object-cover w-full h-full p-0 dark:bg-[#1e1f21]"
                />
              </div>

              <!-- Garment data in the footer -->
              <template #footer>
                <div class="p-0">
                  <h3 class="text-gray-400 text-xs text-center">
                    {{ model.name }}
                  </h3>
                </div>
              </template>
            </UCard>
          </div>
        </div>
      </UDashboardPanelContent>
    </UDashboardPanel>
  </UDashboardPage>
</template>

<style>
.hovercard {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.9;
}
.hovercard:hover {
  transform: scale(1.05);
  opacity: 1;
}
</style>
